import jobadService from '@/api/jobad.service'

const actions = {
  uploadJobadThumbnail(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .uploadJobadThumbnail(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  deleteJobadThumbnail(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .deleteJobadThumbnail(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getJobAdByBookingId(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .getJobAdByBookingId(context, data)
        .then(response => {
          context.commit('jobAd', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  publishJobAdvertisement(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .publishJobAdvertisement(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  createJobAdGeneralInfo(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .createJobAdGeneralInfo(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  updateJobAdGeneralInfo(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .updateJobAdGeneralInfo(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  addRecruiterJobAd(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .addRecruiterJobAd(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  removeRecruiterJobAd(context, data) {
    var promise = new Promise((resolve, reject) => {
      jobadService
        .removeRecruiterJobAd(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  }
}

export default actions
